/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { authCodeFlowConfig } from './auth.config';
import { filter, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { UserPermissions } from 'src/app/models/user';
import { isDefined } from 'src/app/shared/utils';
import { AuthRepository } from '../../repositories/auth.repository';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(private oauthService: OAuthService, private authRepository: AuthRepository) {
    this.oauthService.configure(authCodeFlowConfig);
    this.oauthService.setStorage(localStorage);
    this.login();
  }

  getUserAccessPermissions(): Observable<string[]> {
    return this.authRepository.canAccess$;
  }

  getRedirectPath(): Observable<string | undefined> {
    return this.authRepository.redirectPath$;
  }

  updateRedirectPath(path: string | undefined): void {
    this.authRepository.updateRedirectPath(path);
  }

  authSubscription = this.events.pipe(filter((e) => e.type === 'token_received')).subscribe((_) => {
    this.decodeToken();
  });

  loadDiscoveryDocumentAndLogin(): void {
    this.oauthService.logOut();
    this.oauthService.loadDiscoveryDocumentAndLogin().catch((err) => {});
  }

  login(): void {
    this.oauthService.loadDiscoveryDocumentAndLogin().catch((err) => {});
    this.oauthService.setupAutomaticSilentRefresh();
  }

  logoutCognitoDirect(): void {
    this.oauthService.logOut();
    this.authRepository.updateUser(undefined);
    this.authRepository.updateRedirectPath(undefined);

    window.location.href = `${environment.logoutUrl}?client_id=${authCodeFlowConfig.clientId!}&logout_uri=${
      window.location.origin
    }/landing`;
  }
  get events(): Observable<OAuthEvent> {
    return this.oauthService.events;
  }
  get idToken(): string {
    return this.oauthService.getIdToken();
  }

  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }

  get hasValidAccessToken(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  get hasValidIdToken(): boolean {
    return this.oauthService.hasValidIdToken();
  }

  refresh(): void {
    void this.oauthService.refreshToken();
  }

  decodeToken(): void {
    const decodedToken = jwtDecode<UserPermissions>(this.accessToken);

    const permissionToAccessMappings: Record<string, string> = {
      'READ:WEB_APP': 'web_app',
      'READ:UTILIZATION_SOLUTION': 'utilization',
      'READ:HUMIDITY_SOLUTION': 'humidity',
      'READ:COMPONENT': 'components',
      'READ:PROJECT': 'projects',
      'READ:INCIDENT': 'incidents',
      'READ:GEOFENCE': 'geofence',
      'READ:DEVICE_CONFIG': 'settings',
      'CREATE:COMPONENT': 'component_create',
      'CREATE:COMPONENT_TYPE': 'component_types',
      'CREATE:PROJECT': 'projects_create',
    };

    const mappedAccess = decodedToken.poly_permissions
      .split(',')
      .map((x) => permissionToAccessMappings[x])
      .filter((y) => isDefined(y));

    const user = {
      userId: decodedToken.username,
      organisation: {
        organisationId: decodedToken.poly_organisation,
        canAccess: mappedAccess,
      },
    };
    this.authRepository.updateUser(user.organisation);
  }

  getAccessTokenTimeout(): number {
    const exp = this.oauthService.getAccessTokenExpiration();
    /* const d = new Date();
    d.setTime(exp); */

    return exp;
  }
  logout(): void {
    this.oauthService.logOut();
  }
}
